var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-3_svgrepo.com",
    clipPath: "url(#clip0_988_320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.7557 20.7783C34.1051 20.7783 36.01 18.8746 36.01 16.5252C36.01 14.1759 34.105 12.2709 31.7557 12.2709C29.4069 12.2709 27.502 14.1759 27.502 16.5252C27.502 18.8746 29.4069 20.7783 31.7557 20.7783Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.2033 24.8776C37.0138 23.7385 36.0722 22.1443 35.3596 21.4322C35.2657 21.3378 34.8461 21.316 34.7328 21.3862C33.8663 21.9191 32.8485 22.2327 31.7562 22.2327C30.665 22.2327 29.6472 21.9191 28.7806 21.3862C28.6668 21.316 28.2478 21.3378 28.154 21.4322C27.9547 21.6314 27.7373 21.8966 27.5254 22.2042C28.0988 23.2838 28.5536 24.4307 28.7177 25.4183C28.8817 26.4083 28.8285 27.3456 28.5632 28.2C29.5054 28.5409 30.6353 28.6905 31.7561 28.6905C34.6796 28.6905 37.6714 27.6768 37.2033 24.8776Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6426 18.9836C22.45 18.9836 25.5369 15.8967 25.5369 12.0893C25.5369 8.28307 22.45 5.19617 18.6426 5.19617C14.8357 5.19617 11.75 8.28307 11.75 12.0893C11.75 15.8967 14.8357 18.9836 18.6426 18.9836Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.4807 20.0396C24.3311 19.8906 23.6517 19.8526 23.467 19.9669C22.0616 20.8316 20.4123 21.3378 18.6429 21.3378C16.8749 21.3378 15.2247 20.8316 13.82 19.9669C13.6354 19.8525 12.956 19.8906 12.8064 20.0396C11.6487 21.1961 10.1228 23.7816 9.8158 25.6248C9.05889 30.165 13.9085 31.8041 18.6429 31.8041C23.3786 31.8041 28.2281 30.165 27.4712 25.6248C27.1642 23.7816 25.6384 21.1961 24.4807 20.0396Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.74751 20.7783C8.09629 20.7783 10.0012 18.8746 10.0012 16.5252C10.0012 14.1759 8.09629 12.2709 5.74751 12.2709C3.39809 12.2709 1.49316 14.1759 1.49316 16.5252C1.49316 18.8746 3.39809 20.7783 5.74751 20.7783Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.56933 25.4183C8.74378 24.381 9.23598 23.1597 9.85305 22.0304C9.68106 21.7955 9.50914 21.5909 9.35045 21.4322C9.25657 21.3378 8.83758 21.316 8.72376 21.3862C7.85722 21.9191 6.83936 22.2327 5.74772 22.2327C4.65593 22.2327 3.63742 21.9191 2.7716 21.3862C2.65829 21.316 2.23814 21.3378 2.14426 21.4322C1.42977 22.1443 0.490681 23.7385 0.300478 24.8776C-0.166936 27.6768 2.82428 28.6904 5.74772 28.6904C6.79102 28.6904 7.84458 28.562 8.74378 28.2684C8.46042 27.3965 8.40044 26.4373 8.56933 25.4183Z",
    fill: "#E0B959"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(0.251953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersIcon);
export default __webpack_public_path__ + "static/media/PartnersIcon.6995ef065099602193376faff0531128.svg";
export { ForwardRef as ReactComponent };